import Vue from "vue";
import "plugins/index.js";
import router from "../router";
import VueGtag from "vue-gtag";
import { init as initVueList } from "plugins/v-list";
import OneSignalVue from "onesignal-vue";
/**
 * Cropper
 */
import VueCropper from "vue-cropperjs";

/**
 * Click Outside
 */
import vClickOutside from "v-click-outside";

Vue.use(vClickOutside);
Vue.use(VueCropper);
Vue.use(OneSignalVue);
initVueList();

/**
 * Google Tag Manager
 */
Vue.use(
  VueGtag,
  {
    config: { id: "GTM-PK3RK5G" },
  },
  router
);
